import styled from "styled-components";
import { Anchor as _Anchor } from "../styles";

export const Anchor = styled(_Anchor)``;
